/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Quick_Other_AgentsInputs */

const en_mcp_quick_other_agents = /** @type {(inputs: Mcp_Quick_Other_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other agents`)
};

const es_mcp_quick_other_agents = /** @type {(inputs: Mcp_Quick_Other_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otros agentes`)
};

/**
* | output |
* | --- |
* | "Other agents" |
*
* @param {Mcp_Quick_Other_AgentsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_quick_other_agents = /** @type {((inputs?: Mcp_Quick_Other_AgentsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Quick_Other_AgentsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_quick_other_agents(inputs)
	return en_mcp_quick_other_agents(inputs)
});